import React from 'react';
const DateFormat = (props) => {
  let format = (d) => d.toString().replace(/\w+ (\w+) (\d+) (\d+).*/, '$1 $2, $3');
  return <>{format(props?.date)}</>;
};

export default DateFormat;
